import React from 'react'

import image1 from '../assets/images/common/boton-referencias.png';
import image2 from '../assets/images/common/boton-volver-menu.png';
import image3 from '../assets/images/common/familia-pharmaton.png';
import image4 from '../assets/images/common/fondo-naranja.png';
import image5 from '../assets/images/common/franja-naranja.png';
import image6 from '../assets/images/common/logo-familia-pharmaton.png';
import image7 from '../assets/images/common/logo-pharmaton-blanco.png';
import image8 from '../assets/images/common/logo-pharmaton-naranja.png';
import image9 from '../assets/images/common/logo-pharmaton.png';
import image10 from '../assets/images/common/reloj.png';

import image11 from '../assets/images/finish/adios.png';
import image12 from '../assets/images/finish/boton-buena.png';
import image13 from '../assets/images/finish/boton-mala.png';
import image14 from '../assets/images/finish/boton-regular.png';
import image15 from '../assets/images/finish/texto-apreciamos.png';
import image16 from '../assets/images/finish/texto-gracias.png';
import image17 from '../assets/images/finish/texto-legal.png';
import image18 from '../assets/images/finish/texto-maximo.png';

import image19 from '../assets/images/home/boton-registrarse.png';
import image20 from '../assets/images/home/cuadro-registro.png';
import image21 from '../assets/images/home/fondo-inicio.png';

import image22 from '../assets/images/level-1/aviso-morado-creciendo.png';
import image23 from '../assets/images/level-1/cuadro-correcto.png';
import image24 from '../assets/images/level-1/cuadro-descifremos.png';
import image25 from '../assets/images/level-1/cuadro-excelente-acertaste.png';
import image26 from '../assets/images/level-1/cuadro-excelente-recuerda.png';
import image27 from '../assets/images/level-1/cuadro-fallaste.png';
import image28 from '../assets/images/level-1/cuadro-muy-bien.png';
import image29 from '../assets/images/level-1/cuadro-pregunta-1-modal.png';
import image30 from '../assets/images/level-1/cuadro-pregunta-1.png';
import image31 from '../assets/images/level-1/cuadro-pregunta-2-modal.png';
import image32 from '../assets/images/level-1/cuadro-pregunta-2.png';
import image33 from '../assets/images/level-1/cuadro-pregunta-3-modal.png';
import image34 from '../assets/images/level-1/cuadro-pregunta-3.png';
import image35 from '../assets/images/level-1/cuadro-pregunta-fin.png';
import image36 from '../assets/images/level-1/cuadro-referencias.png';
import image37 from '../assets/images/level-1/cuadro-respuesta-incorrecta.png';
import image38 from '../assets/images/level-1/cuadro-ups-fallaste.png';
import image39 from '../assets/images/level-1/cuadro-ups-intentalo-nuevo.png';
import image40 from '../assets/images/level-1/cuadro-ups-tiempo.png';
import image41 from '../assets/images/level-1/fondo-cuarto-nina.png';
import image42 from '../assets/images/level-1/mensaje-reto-1.png';
import image43 from '../assets/images/level-1/nina-1.png';
import image44 from '../assets/images/level-1/nina-2.png';
import image45 from '../assets/images/level-1/nivel-1.png';

import image46 from '../assets/images/level-2/bacteria-1.png';
import image47 from '../assets/images/level-2/bacteria-2.png';
import image48 from '../assets/images/level-2/boton-menu.png';
import image49 from '../assets/images/level-2/boton-referencias.png';
import image50 from '../assets/images/level-2/burbuja-bien.png';
import image51 from '../assets/images/level-2/burbuja-mal.png';
import image52 from '../assets/images/level-2/cuadro-fallaste-defensas.png';
import image53 from '../assets/images/level-2/cuadro-fallaste-energia.png';
import image54 from '../assets/images/level-2/cuadro-fallaste-obstaculo.png';
import image55 from '../assets/images/level-2/cuadro-inmunidad.png';
import image56 from '../assets/images/level-2/cuadro-instrucciones.png';
import image57 from '../assets/images/level-2/cuadro-referencias.png';
import image58 from '../assets/images/level-2/energia-icono.png';
import image59 from '../assets/images/level-2/fallaste.png';
import image60 from '../assets/images/level-2/fondo-1.png';
import image61 from '../assets/images/level-2/fondo-2.png';
import image62 from '../assets/images/level-2/fondo-interactivo-arboles.png';
import image63 from '../assets/images/level-2/fondo-interactivo-cielo.png';
import image64 from '../assets/images/level-2/hombre-agachado.png';
import image65 from '../assets/images/level-2/hombre-corriendo.png';
import image66 from '../assets/images/level-2/hombre-nina.png';
import image67 from '../assets/images/level-2/hombre-saltando.png';
import image68 from '../assets/images/level-2/hombre.png';
import image69 from '../assets/images/level-2/intrucciones.png';
import image70 from '../assets/images/level-2/juego-flecha-amarilla-abajo.png';
import image71 from '../assets/images/level-2/juego-flecha-amarilla-arriba.png';
import image72 from '../assets/images/level-2/juego-icono-final.png';
import image73 from '../assets/images/level-2/juego-icono-hombre.png';
import image74 from '../assets/images/level-2/juego-icono-inicio.png';
import image75 from '../assets/images/level-2/mensaje-empezar.png';
import image76 from '../assets/images/level-2/mensaje-logramos.png';
import image77 from '../assets/images/level-2/nivel-2.png';
import image78 from '../assets/images/level-2/producto-juego.png';
import image79 from '../assets/images/level-2/referencias.png';
import image80 from '../assets/images/level-2/vidas-icono.png';

import image81 from '../assets/images/level-3/abuelitos.png';
import image82 from '../assets/images/level-3/boton-menu.png';
import image83 from '../assets/images/level-3/boton-referencias.png';
import image84 from '../assets/images/level-3/cuadro-excelente.png';
import image85 from '../assets/images/level-3/cuadro-pharmaton.png';
import image86 from '../assets/images/level-3/cuadro-referencias.png';
import image87 from '../assets/images/level-3/cuadro-ups.png';
import image88 from '../assets/images/level-3/ficha-b2.png';
import image89 from '../assets/images/level-3/ficha-b6.png';
import image90 from '../assets/images/level-3/ficha-b9.png';
import image91 from '../assets/images/level-3/ficha-c.png';
import image92 from '../assets/images/level-3/ficha-omega3.png';
import image93 from '../assets/images/level-3/ficha-pharmaton.png';
import image94 from '../assets/images/level-3/ficha-zn.png';
import image95 from '../assets/images/level-3/fondo.png';
import image96 from '../assets/images/level-3/mensaje-b2.png';
import image97 from '../assets/images/level-3/mensaje-b6.png';
import image98 from '../assets/images/level-3/mensaje-b9.png';
import image99 from '../assets/images/level-3/mensaje-c.png';
import image100 from '../assets/images/level-3/mensaje-empezar.png';
import image101 from '../assets/images/level-3/mensaje-omega3.png';
import image102 from '../assets/images/level-3/mensaje-zn.png';
import image103 from '../assets/images/level-3/nivel-3.png';
import image104 from '../assets/images/level-3/referencias.png';
import image105 from '../assets/images/level-3/texto-encuentra.png';

import image106 from '../assets/images/level-4/azul.png';
import image107 from '../assets/images/level-4/bolita-disparar.png';
import image108 from '../assets/images/level-4/bolita-tiros.png';
import image109 from '../assets/images/level-4/boton-menu.png';
import image110 from '../assets/images/level-4/boton-referencias.png';
import image111 from '../assets/images/level-4/cajas-pharmaton.png';
import image112 from '../assets/images/level-4/cuadro-bien-hombre-1.png';
import image113 from '../assets/images/level-4/cuadro-bien-hombre-2.png';
import image114 from '../assets/images/level-4/cuadro-bien-hombre-3.png';
import image115 from '../assets/images/level-4/cuadro-bien-hombre-4.png';
import image116 from '../assets/images/level-4/cuadro-bien-hombre-5.png';
import image117 from '../assets/images/level-4/cuadro-bien-hombre-6.png';
import image118 from '../assets/images/level-4/cuadro-bien-mujer-1.png';
import image119 from '../assets/images/level-4/cuadro-bien-mujer-2.png';
import image120 from '../assets/images/level-4/cuadro-bien-mujer-3.png';
import image121 from '../assets/images/level-4/cuadro-bien-mujer-4.png';
import image122 from '../assets/images/level-4/cuadro-bien-mujer-5.png';
import image123 from '../assets/images/level-4/cuadro-bien-mujer-6.png';
import image124 from '../assets/images/level-4/cuadro-instrucciones.png';
import image125 from '../assets/images/level-4/cuadro-lograste.png';
import image126 from '../assets/images/level-4/cuadro-pharmaton.png';
import image127 from '../assets/images/level-4/cuadro-referencias.png';
import image128 from '../assets/images/level-4/cuadro-ups.png';
import image129 from '../assets/images/level-4/fondo.png';
import image130 from '../assets/images/level-4/mensaje-empezar.png';
import image131 from '../assets/images/level-4/morada.png';
import image132 from '../assets/images/level-4/naranja.png';
import image133 from '../assets/images/level-4/nivel-4.png';
import image134 from '../assets/images/level-4/personas.png';
import image135 from '../assets/images/level-4/roja.png';
import image136 from '../assets/images/level-4/verde.png';

import image137 from '../assets/images/menu/foto-nivel-1.png';
import image138 from '../assets/images/menu/foto-nivel-2.png';
import image139 from '../assets/images/menu/foto-nivel-3.png';
import image140 from '../assets/images/menu/foto-nivel-4.png';

import image141 from '../assets/images/welcome/boton-empecemos.png';
import image142 from '../assets/images/welcome/texto-acompananos.png';
import image143 from '../assets/images/welcome/texto-ayudanos.png';
import image144 from '../assets/images/welcome/texto-selecciona.png';

const Preload = () => {

  if (window.cordova) {
    document.addEventListener('deviceready', () => {
      console.log('carga completa');

      setTimeout(() => {
        const preload = document.querySelector('.Preload');
        preload.classList.add('hidden');
      }, 1000);
    }, false);
  } else {
    window.onload = () => {
      console.log('carga completa');
  
      setTimeout(() => {
        const preload = document.querySelector('.Preload');
        preload.classList.add('hidden');
      }, 1000);
    }
  }

  var number = 0;

  const increment = () => {
    if (!images && !percent) {
      var images = document.querySelector('.Preload-images');
      var percent = document.querySelector('.Preload-percent');
      var imagesCount = images.childElementCount;
      var unit = 100 / imagesCount;
    }
    
    number += unit;
    percent.innerHTML = Math.ceil(number) + '%';
  }

  return (
    <React.Fragment>
      <div className='Preload'>
        <div className='Preload-images'>
          <img src={image1} alt="Preload" onLoad={() => increment()} />
          <img src={image2} alt="Preload" onLoad={() => increment()} />
          <img src={image3} alt="Preload" onLoad={() => increment()} />
          <img src={image4} alt="Preload" onLoad={() => increment()} />
          <img src={image5} alt="Preload" onLoad={() => increment()} />
          <img src={image6} alt="Preload" onLoad={() => increment()} />
          <img src={image7} alt="Preload" onLoad={() => increment()} />
          <img src={image8} alt="Preload" onLoad={() => increment()} />
          <img src={image9} alt="Preload" onLoad={() => increment()} />
          <img src={image10} alt="Preload" onLoad={() => increment()} />

          <img src={image11} alt="Preload" onLoad={() => increment()} />
          <img src={image12} alt="Preload" onLoad={() => increment()} />
          <img src={image13} alt="Preload" onLoad={() => increment()} />
          <img src={image14} alt="Preload" onLoad={() => increment()} />
          <img src={image15} alt="Preload" onLoad={() => increment()} />
          <img src={image16} alt="Preload" onLoad={() => increment()} />
          <img src={image17} alt="Preload" onLoad={() => increment()} />
          <img src={image18} alt="Preload" onLoad={() => increment()} />

          <img src={image19} alt="Preload" onLoad={() => increment()} />
          <img src={image20} alt="Preload" onLoad={() => increment()} />
          <img src={image21} alt="Preload" onLoad={() => increment()} />

          <img src={image22} alt="Preload" onLoad={() => increment()} />
          <img src={image23} alt="Preload" onLoad={() => increment()} />
          <img src={image24} alt="Preload" onLoad={() => increment()} />
          <img src={image25} alt="Preload" onLoad={() => increment()} />
          <img src={image26} alt="Preload" onLoad={() => increment()} />
          <img src={image27} alt="Preload" onLoad={() => increment()} />
          <img src={image28} alt="Preload" onLoad={() => increment()} />
          <img src={image29} alt="Preload" onLoad={() => increment()} />
          <img src={image30} alt="Preload" onLoad={() => increment()} />
          <img src={image31} alt="Preload" onLoad={() => increment()} />
          <img src={image32} alt="Preload" onLoad={() => increment()} />
          <img src={image33} alt="Preload" onLoad={() => increment()} />
          <img src={image34} alt="Preload" onLoad={() => increment()} />
          <img src={image35} alt="Preload" onLoad={() => increment()} />
          <img src={image36} alt="Preload" onLoad={() => increment()} />
          <img src={image37} alt="Preload" onLoad={() => increment()} />
          <img src={image38} alt="Preload" onLoad={() => increment()} />
          <img src={image39} alt="Preload" onLoad={() => increment()} />
          <img src={image40} alt="Preload" onLoad={() => increment()} />
          <img src={image41} alt="Preload" onLoad={() => increment()} />
          <img src={image42} alt="Preload" onLoad={() => increment()} />
          <img src={image43} alt="Preload" onLoad={() => increment()} />
          <img src={image44} alt="Preload" onLoad={() => increment()} />
          <img src={image45} alt="Preload" onLoad={() => increment()} />

          <img src={image46} alt="Preload" onLoad={() => increment()} />
          <img src={image47} alt="Preload" onLoad={() => increment()} />
          <img src={image48} alt="Preload" onLoad={() => increment()} />
          <img src={image49} alt="Preload" onLoad={() => increment()} />
          <img src={image50} alt="Preload" onLoad={() => increment()} />
          <img src={image51} alt="Preload" onLoad={() => increment()} />
          <img src={image52} alt="Preload" onLoad={() => increment()} />
          <img src={image53} alt="Preload" onLoad={() => increment()} />
          <img src={image54} alt="Preload" onLoad={() => increment()} />
          <img src={image55} alt="Preload" onLoad={() => increment()} />
          <img src={image56} alt="Preload" onLoad={() => increment()} />
          <img src={image57} alt="Preload" onLoad={() => increment()} />
          <img src={image58} alt="Preload" onLoad={() => increment()} />
          <img src={image59} alt="Preload" onLoad={() => increment()} />
          <img src={image60} alt="Preload" onLoad={() => increment()} />
          <img src={image61} alt="Preload" onLoad={() => increment()} />
          <img src={image62} alt="Preload" onLoad={() => increment()} />
          <img src={image63} alt="Preload" onLoad={() => increment()} />
          <img src={image64} alt="Preload" onLoad={() => increment()} />
          <img src={image65} alt="Preload" onLoad={() => increment()} />
          <img src={image66} alt="Preload" onLoad={() => increment()} />
          <img src={image67} alt="Preload" onLoad={() => increment()} />
          <img src={image68} alt="Preload" onLoad={() => increment()} />
          <img src={image69} alt="Preload" onLoad={() => increment()} />
          <img src={image70} alt="Preload" onLoad={() => increment()} />
          <img src={image71} alt="Preload" onLoad={() => increment()} />
          <img src={image72} alt="Preload" onLoad={() => increment()} />
          <img src={image73} alt="Preload" onLoad={() => increment()} />
          <img src={image74} alt="Preload" onLoad={() => increment()} />
          <img src={image75} alt="Preload" onLoad={() => increment()} />
          <img src={image76} alt="Preload" onLoad={() => increment()} />
          <img src={image77} alt="Preload" onLoad={() => increment()} />
          <img src={image78} alt="Preload" onLoad={() => increment()} />
          <img src={image79} alt="Preload" onLoad={() => increment()} />
          <img src={image80} alt="Preload" onLoad={() => increment()} />

          <img src={image81} alt="Preload" onLoad={() => increment()} />
          <img src={image82} alt="Preload" onLoad={() => increment()} />
          <img src={image83} alt="Preload" onLoad={() => increment()} />
          <img src={image84} alt="Preload" onLoad={() => increment()} />
          <img src={image85} alt="Preload" onLoad={() => increment()} />
          <img src={image86} alt="Preload" onLoad={() => increment()} />
          <img src={image87} alt="Preload" onLoad={() => increment()} />
          <img src={image88} alt="Preload" onLoad={() => increment()} />
          <img src={image89} alt="Preload" onLoad={() => increment()} />
          <img src={image90} alt="Preload" onLoad={() => increment()} />
          <img src={image91} alt="Preload" onLoad={() => increment()} />
          <img src={image92} alt="Preload" onLoad={() => increment()} />
          <img src={image93} alt="Preload" onLoad={() => increment()} />
          <img src={image94} alt="Preload" onLoad={() => increment()} />
          <img src={image95} alt="Preload" onLoad={() => increment()} />
          <img src={image96} alt="Preload" onLoad={() => increment()} />
          <img src={image97} alt="Preload" onLoad={() => increment()} />
          <img src={image98} alt="Preload" onLoad={() => increment()} />
          <img src={image99} alt="Preload" onLoad={() => increment()} />
          <img src={image100} alt="Preload" onLoad={() => increment()} />
          <img src={image101} alt="Preload" onLoad={() => increment()} />
          <img src={image102} alt="Preload" onLoad={() => increment()} />
          <img src={image103} alt="Preload" onLoad={() => increment()} />
          <img src={image104} alt="Preload" onLoad={() => increment()} />
          <img src={image105} alt="Preload" onLoad={() => increment()} />

          <img src={image106} alt="Preload" onLoad={() => increment()} />
          <img src={image107} alt="Preload" onLoad={() => increment()} />
          <img src={image108} alt="Preload" onLoad={() => increment()} />
          <img src={image109} alt="Preload" onLoad={() => increment()} />
          <img src={image110} alt="Preload" onLoad={() => increment()} />
          <img src={image111} alt="Preload" onLoad={() => increment()} />
          <img src={image112} alt="Preload" onLoad={() => increment()} />
          <img src={image113} alt="Preload" onLoad={() => increment()} />
          <img src={image114} alt="Preload" onLoad={() => increment()} />
          <img src={image115} alt="Preload" onLoad={() => increment()} />
          <img src={image116} alt="Preload" onLoad={() => increment()} />
          <img src={image117} alt="Preload" onLoad={() => increment()} />
          <img src={image118} alt="Preload" onLoad={() => increment()} />
          <img src={image119} alt="Preload" onLoad={() => increment()} />
          <img src={image120} alt="Preload" onLoad={() => increment()} />
          <img src={image121} alt="Preload" onLoad={() => increment()} />
          <img src={image122} alt="Preload" onLoad={() => increment()} />
          <img src={image123} alt="Preload" onLoad={() => increment()} />
          <img src={image124} alt="Preload" onLoad={() => increment()} />
          <img src={image125} alt="Preload" onLoad={() => increment()} />
          <img src={image126} alt="Preload" onLoad={() => increment()} />
          <img src={image127} alt="Preload" onLoad={() => increment()} />
          <img src={image128} alt="Preload" onLoad={() => increment()} />
          <img src={image129} alt="Preload" onLoad={() => increment()} />
          <img src={image130} alt="Preload" onLoad={() => increment()} />
          <img src={image131} alt="Preload" onLoad={() => increment()} />
          <img src={image132} alt="Preload" onLoad={() => increment()} />
          <img src={image133} alt="Preload" onLoad={() => increment()} />
          <img src={image134} alt="Preload" onLoad={() => increment()} />
          <img src={image135} alt="Preload" onLoad={() => increment()} />
          <img src={image136} alt="Preload" onLoad={() => increment()} />

          <img src={image137} alt="Preload" onLoad={() => increment()} />
          <img src={image138} alt="Preload" onLoad={() => increment()} />
          <img src={image139} alt="Preload" onLoad={() => increment()} />
          <img src={image140} alt="Preload" onLoad={() => increment()} />

          <img src={image141} alt="Preload" onLoad={() => increment()} />
          <img src={image142} alt="Preload" onLoad={() => increment()} />
          <img src={image143} alt="Preload" onLoad={() => increment()} />
          <img src={image144} alt="Preload" onLoad={() => increment()} />
        </div>

        <div className='Preload-overlay'>
          <div className="Preload-icon" />
          <div className='Preload-percent'>0</div>
        </div>
      </div>
    </React.Fragment>
  ); 
}

export default Preload;